export const PartnerMetricNames: Record<string, string> = {
    'app-core-cost': 'App Core Cost',
    'daily-p99-utilization': 'Daily P99 Utilization',
    'daily-app-request-cores': 'Daily App Request Cores',
    'daily-app-limit-cores': 'Daily App Limit Cores',
    'daily-app-empty-cores': 'Daily App Empty Cores'
}

export const PartnerMetrics = [
    "app-core-cost",
    "daily-p99-utilization",
    "daily-app-request-cores",
    "daily-app-limit-cores",
    "daily-app-empty-cores"
];


export const PartnerMetricNamesForAppCoreV2: Record<string, string> = {
    // 'app-core-cost': 'App Core Cost',
    'daily-p99-utilization': 'Daily P99 Utilization',
    "daily-app-cores": 'Daily App Cores',
    'daily-app-empty-cores': 'Daily App Empty Cores'
}

export const PartnerMetricsForAppCoreV2 = [
    // "app-core-cost",
    "daily-p99-utilization",
    "daily-app-cores",
    "daily-app-empty-cores"
];

export const PlatformMetricNames: Record<string, string> = {
    'daily-total-cores': 'Daily total Cores',
    'avg-total-cores': 'Avg total Cores',
    'daily-overhead-cores': 'Daily Overhead Cores',
    'avg-overhead-cores': 'Avg Overhead Cores',
    'daily-fragmentation-cores': 'Daily Fragmentation Cores',
    'avg-fragmentation-cores': 'Avg Fragmentation Cores',
    'daily-infra-cores': 'Daily Infra Cores',
    'avg-infra-cores': 'Avg Infra Cores',
    'daily-empty-cores': 'Daily Empty Cores',
    'avg-empty-cores': 'Avg Empty Cores',
    'daily-app-cores': 'Daily App Cores',
    'avg-app-cores': 'Avg App Cores',
    'daily-empty-app-cores': 'Daily Empty App Cores',
    'avg-empty-app-cores': 'Avg Empty App Cores',
    'daily-p99-utilization': 'Daily P99 Utilization',
    'avg-p99-utilization': 'Avg P99 Utilization',
}

export const PlatformMetrics = [
    'total-cores',
    'overhead-cores',
    'fragmentation-cores',
    'infra-cores',
    'empty-cores',
    'app-cores',
    'empty-app-cores',
    'p99-utilization',
]